import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['wrapper', 'input', 'editor', 'helper'];
  static values = {
    frontendValidation: Boolean,
    helperClass: { type: String, default: 'mt-8 text-paragraph-s text-red-1000' },
  };

  connect() {
    this.addValidationListener();
    this._onEditorChange = () => this.clearValidationError();
    if (this.hasEditorTarget) {
      this.editorTarget.addEventListener('trix-change', this._onEditorChange);
    }
  }

  disconnect() {
    if (this._validatedForm && this._onFormSubmit) {
      this._validatedForm.removeEventListener('submit', this._onFormSubmit);
    }
    if (this.hasEditorTarget && this._onEditorChange) {
      this.editorTarget.removeEventListener('trix-change', this._onEditorChange);
    }
  }

  addValidationListener() {
    const form = this.element.closest('form');
    if (!form) return;

    this._onFormSubmit = (event) => {
      if (this.frontendValidationValue && this.isBlank()) {
        event.preventDefault();
        event.stopPropagation();
        this.showValidationError();
        if (this.hasEditorTarget) this.editorTarget.focus();
      }
    };

    form.addEventListener('submit', this._onFormSubmit);
    this._validatedForm = form;
  }

  isBlank() {
    if (!this.hasInputTarget) return true;

    const html = this.inputTarget.value || '';
    const hasAttachment = /<figure|<img/i.test(html);
    const text = html.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ').trim();

    return text.length === 0 && !hasAttachment;
  }

  showValidationError() {
    if (this.hasWrapperTarget) {
      this.wrapperTarget.classList.add('border-red-300');
    }

    if (!this.hasHelperTarget) {
      const helperText = document.createElement('p');
      helperText.dataset.trixInputTarget = 'helper';
      helperText.className = this.helperClassValue;
      const label = this.element.querySelector('label');
      const fieldName = label ? label.textContent.trim().replace(/\s*\*\s*$/, '') : 'Field';
      helperText.textContent = `${fieldName} can't be blank`;
      this.element.appendChild(helperText);
    } else {
      this.helperTarget.style.display = '';
      this.helperTarget.classList.add('text-red-1000');
    }
  }

  clearValidationError() {
    if (this.frontendValidationValue && this.isBlank()) return;

    if (this.hasWrapperTarget) {
      this.wrapperTarget.classList.remove('border-red-300');
    }

    if (this.hasHelperTarget && this.helperTarget.dataset.backendError !== 'true') {
      this.helperTarget.style.display = 'none';
    }
  }
}
